var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoEye = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "15px",
    viewBox: "0 0 22 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "36ADB944-585D-44C4-BCFA-0556B79373A4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,19.5 C9.51391517,19.5 7.14514746,18.2641212 4.9467199,16.2348034 C4.19700818,15.5427619 3.51984409,14.8040374 2.92437109,14.0648295 C2.56453552,13.6181371 2.30880878,13.2659888 2.16794971,13.0547002 L1.8125383,12.5215831 L2.14834168,11.9759026 C2.28791047,11.7491033 2.54227236,11.3696454 2.90066266,10.8876722 C3.49442763,10.0891607 4.16983815,9.29094829 4.91789322,8.54289322 C7.11858669,6.34219975 9.49324778,5 12,5 C14.5067522,5 16.8814133,6.34219975 19.0821068,8.54289322 C19.8301619,9.29094829 20.5055724,10.0891607 21.0993373,10.8876722 C21.4577276,11.3696454 21.7120895,11.7491033 21.8516583,11.9759026 L22.1874617,12.5215831 L21.8320503,13.0547002 C21.6911912,13.2659888 21.4354645,13.6181371 21.0756289,14.0648295 C20.4801559,14.8040374 19.8029918,15.5427619 19.0532801,16.2348034 C16.8548525,18.2641212 14.4860848,19.5 12,19.5 Z M4.48187891,12.8101705 C5.01921841,13.4772126 5.63111682,14.1447381 6.3032801,14.7651966 C8.16735254,16.4858788 10.1110848,17.5 12,17.5 C13.8889152,17.5 15.8326475,16.4858788 17.6967199,14.7651966 C18.3688832,14.1447381 18.9807816,13.4772126 19.5181211,12.8101705 C19.6148792,12.6900569 19.7025762,12.5784499 19.7808611,12.4766626 C19.6924401,12.3510736 19.5968705,12.2188659 19.4944127,12.0810778 C18.9553651,11.3561518 18.3417131,10.6309267 17.6678932,9.95710678 C15.8060867,8.09530025 13.8682478,7 12,7 C10.1317522,7 8.19391331,8.09530025 6.33210678,9.95710678 C5.65828685,10.6309267 5.04463487,11.3561518 4.50558734,12.0810778 C4.40312953,12.2188659 4.30755987,12.3510736 4.21913893,12.4766626 C4.29742379,12.5784499 4.38512078,12.6900569 4.48187891,12.8101705 Z M12,15 C10.3431458,15 9,13.6568542 9,12 C9,10.3431458 10.3431458,9 12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "28-contract",
    transform: "translate(-1391.000000, -1103.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company-assets",
    transform: "translate(430.000000, 920.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "row2",
    transform: "translate(30.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_eye",
    transform: "translate(930.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FF5000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_eye.55ff36e8cb7035659db022fc6da40773.svg";